import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SelectNofashimComponent } from "./select-nofashim/select-nofashim.component";
import { HomeComponent } from "app/nofesh/home/home.component";
import { CanActivateViaOAuthGuard } from "app/oAuth.canActivateGuard";

const routes: Routes = [
    {
        path: 'favorites', canActivate: [CanActivateViaOAuthGuard] ,children: [
            { path: 'select-nofashim', component: SelectNofashimComponent }
          ]
    }
  ];
  
  @NgModule({
    imports: [
      RouterModule.forChild(routes)
    ],
    exports: [
      RouterModule
    ]
  })
  export class FavoritesNofashimRouting {}